export enum SpConnectPurposeEnum {
  Unspecified = 'Unspecified',
  Cancellation = 'Cancellation',
  Change = 'Change',
  Original = 'Original',
  Confirmation = 'Confirmation',
  Other = 'Other',
  Pending = 'Pending',
}
